import { all, takeLatest } from 'redux-saga/effects'

import { getNewsSaga } from './sagas/get-news'
import * as actions from './news.actions'

export default function* () {
  yield all([takeLatest(actions.GET_NEWS_REQUEST, getNewsSaga)])
}
